/**
 * Peças comuns de "Simular venda" e do "Cenário do PCP": a ocupação dos
 * períodos antes × depois da mudança e os clientes que passariam a atrasar.
 */
import React from "react";

import { plural } from "../../utils/dinheiro";
import { periodosQueMudam, textoEmpurrado, textoOcupacaoCurta } from "./apresentacaoSimulacao";
import { SELO_VENDA_ASSINADA } from "./apresentacaoVendas";
import { rotuloPedidoCliente } from "./ItemAmbiente";
import { Ponto, Selo } from "./styles";
import { ListaComPonto, Secao, Tabela } from "./stylesSimulacao";

export function OcupacaoAntesDepois({ ocupacao }) {
  const linhas = periodosQueMudam(ocupacao);
  if (linhas.length === 0) return null;
  return (
    <Secao aria-label="Ocupação antes e depois">
      <h3>Ocupação antes × depois</h3>
      <Tabela $colunas="auto auto" role="table" aria-label="Ocupação dos períodos antes e depois">
        <span className="cab">Período</span>
        <span className="cab num">Hoje</span>
        <span className="cab num">Com a mudança</span>
        {linhas.map(({ periodo, antes, depois }) => (
          <React.Fragment key={periodo.chave}>
            <span>{periodo.rotulo}</span>
            <span className="num fraco">{textoOcupacaoCurta(antes)}</span>
            <span className="num forte">
              {depois?.faixa ? <Ponto $tom={depois.faixa.tom} aria-hidden="true" style={{ marginRight: 6 }} /> : null}
              {textoOcupacaoCurta(depois)}
            </span>
          </React.Fragment>
        ))}
      </Tabela>
      <p>Só os períodos que mudam (e o atual, como referência). A cor segue o pior caso da faixa de erro.</p>
    </Secao>
  );
}

export function ListaEmpurrados({ empurrados }) {
  return (
    <Secao aria-label="Clientes empurrados">
      <h3>Quem seria empurrado {empurrados.length ? `(${empurrados.length})` : ""}</h3>
      {empurrados.length === 0 ? (
        <p>Nenhum cliente que hoje está no prazo passa a atrasar.</p>
      ) : (
        <>
          <ListaComPonto>
            {empurrados.map((e) => (
              <li key={`${e.pedido}|${e.cliente}|${e.vendaAssinadaId || ""}`}>
                <i data-tom="warning" aria-hidden="true" />
                <span>
                  {rotuloPedidoCliente(e)}
                  {e.vendaAssinadaId ? <Selo>{SELO_VENDA_ASSINADA}</Selo> : null}
                  <span className="sub">
                    {plural(e.ambientes, "ambiente", "ambientes")} · {textoEmpurrado(e)}
                  </span>
                </span>
              </li>
            ))}
          </ListaComPonto>
          <p>Pela projeção central. A ordem da fila é indicativa: o PCP decide quem sai antes.</p>
        </>
      )}
    </Secao>
  );
}
